import {CONVERSION_LABEL, LEAD_EVENT} from '../../../config.js'
import {googleAds} from '../../../externalTrackers/index.js'
import {
  checkEmailLeadEvent,
  checkOEMLeadEvent,
  checkPhoneLeadEvent,
  checkProfessionalSellerType,
  checkSubscriptionLeadEvent
} from '../../../utils.js'

const CONVERSION_ID = 'AW-1054000236'
const OFFER_TYPE_NEW_VEHICLE = 'nuevo'

const track = googleAds({id: CONVERSION_ID})

const getLabels = ({isProfessionalSellerType, isLeadToOEM, isLeadToSubscriptionAd, isNewVehicle}) => {
  // Lead to OEM (model detail) keeps its current single-label behavior.
  if (isLeadToOEM) return [CONVERSION_LABEL.OEM]

  const labels = [isProfessionalSellerType ? CONVERSION_LABEL.PROFESSIONAL_SELLER : CONVERSION_LABEL.DEFAULT_SELLER]
  if (isNewVehicle) labels.push(CONVERSION_LABEL.OEM)
  if (isLeadToSubscriptionAd) labels.push(CONVERSION_LABEL.SUBSCRIPTION_AD)
  return labels
}

export default ({event, properties, isPage}) => {
  const isEmailLeadEvent = checkEmailLeadEvent({event, properties})
  const isPhoneLeadEvent = checkPhoneLeadEvent({event, properties})
  const isProfessionalSellerType = checkProfessionalSellerType({properties})
  const isLeadToOEM = checkOEMLeadEvent({event, properties})
  const isLeadToSubscriptionAd = checkSubscriptionLeadEvent({properties})
  const isNewVehicle = event === LEAD_EVENT && properties?.offer_type === OFFER_TYPE_NEW_VEHICLE

  if (isEmailLeadEvent || isLeadToOEM || isPhoneLeadEvent) {
    const labels = getLabels({
      isProfessionalSellerType,
      isLeadToOEM,
      isLeadToSubscriptionAd,
      isNewVehicle
    })
    labels.forEach(label => track({label}))
  }
  isPage && track({event: 'page_view', allowAdPersonalization: true})
}
